import { render, staticRenderFns } from "./Swirl.vue?vue&type=template&id=43799fd0&scoped=true&"
import script from "./Swirl.vue?vue&type=script&lang=js&"
export * from "./Swirl.vue?vue&type=script&lang=js&"
import style0 from "./Swirl.vue?vue&type=style&index=0&id=43799fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43799fd0",
  null
  
)

export default component.exports